module.exports = __webpack_public_path__ + "static/perkenalan-keluarga-9281b1681be60f4087784c11224fa4b6.jpg";